import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from './core/auth.service';
import { CommonModule } from '@angular/common';

@Component({
  standalone: false,
  selector: 'app-root',
  template: `
    <div class="min-h-screen bg-surface">
      <header class="bg-white border-b p-4">
        <div class="container mx-auto flex items-center justify-between">
          <a routerLink="/" class="font-serif text-2xl text-primary">Guia Noivas</a>
          <nav class="flex items-center gap-4">
            <a *ngIf="isAdmin" routerLink="/admin" class="text-sm">Admin</a>
            <a *ngIf="isSupplier" routerLink="/painel/perfil" class="text-sm">Painel</a>
            <div *ngIf="auth.user$ | async as user" class="flex items-center gap-2 text-sm border-l pl-4">
              <span class="text-muted">👤</span>
              <span class="font-medium">{{ user.email }}</span>
              <button (click)="logout()" class="text-xs px-2 py-1 border rounded hover:bg-surface">Sair</button>
            </div>
          </nav>
        </div>
      </header>
      
      <main class="container mx-auto p-4 relative">
        <ng-container *ngIf="(auth.initializing$ | async) === true">
          <div class="fixed inset-0 bg-white bg-opacity-70 z-50 flex items-center justify-center">
            <div class="text-center">
              <div class="loader mb-3">Loading...</div>
              <div class="text-sm text-gray-600">Inicializando autenticação...</div>
            </div>
          </div>
        </ng-container>

        <router-outlet></router-outlet>
      </main>
      <app-toast></app-toast>
    </div>
  `
})
export class AppComponent {
  constructor(public auth: AuthService, private router: Router) {}

  get isAdmin() { return this.auth.hasRole('Admin'); }
  get isSupplier() { return this.auth.hasRole('Supplier'); }

  logout() {
    this.auth.logout();
    this.router.navigate(['/auth/login']);
  }
}
